<template>
  <form-element
    class="inputFile"
    :tooltip-content="tooltipContent"
    :tooltip-label="tooltipLabel"
    :errors="errors"
  >
    <div class="inputFile__title">{{ titleLabel }}</div>
    <div class="inputFile__container" :class="{ error: !isEmpty(errors) }">
      <input
        :id="id"
        ref="input"
        class="inputFile__input"
        :name="id"
        type="file"
        :placeholder="placeholder"
        @change="fileChanged"
      />

      <label
        id="labelForInputTypeFile"
        :key="inputValue"
        aria-hidden="true"
        :for="id"
      >
        {{ placeholder }}
        <dotcom-icon
          v-if="!inputValue"
          name="circle-arrow-down"
          art="light"
          class="inputFile__icon"
          :color="
            !isEmpty(errors)
              ? '--c-secondary-color-1'
              : '--c-secondary-neutral-2'
          "
          rotation="180"
        />
        <dotcom-icon
          v-else
          name="xmark"
          art="light"
          class="inputFile__reset"
          :color="
            !isEmpty(errors)
              ? '--c-secondary-color-1'
              : '--c-secondary-neutral-2'
          "
          @click="reset"
        />
      </label>
    </div>
  </form-element>
</template>

<script>
import { isEmpty } from 'lodash'

import FormElement from '../../../components/FormElement'

export default {
  name: 'SanitasInputFile',
  components: {
    FormElement,
    DotcomIcon: () => {
      return import(
        /* webpackChunkName: "dotcom-icon" */
        '@/modules/icon/Icon'
      )
    },
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    titleLabel: {
      type: String,
      default: 'File Upload',
    },
    required: Boolean,
    tooltipContent: {
      type: String,
      default: '',
    },
    tooltipLabel: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      inputValue: null,
      placeholder: '',
    }
  },
  methods: {
    isEmpty,
    fileChanged(event) {
      this.$set(this, 'inputValue', event.target.files[0])

      if (this.inputValue && this.inputValue.name) {
        this.placeholder = this.inputValue.name
      } else {
        this.reset()
      }
    },
    reset(event) {
      if (event) {
        event.preventDefault()
      }
      this.$refs.input.value = null
      this.inputValue = null
      this.placeholder = ''
    },
  },
}
</script>

<style class="scss" scoped>
.inputFile {
  margin-bottom: 20px;
}

.inputFile__title {
  font-weight: 700;
  font-style: normal;
  font-size: 15px;
  line-height: 1.35;
  color: var(--c-primary-neutral-1);
  display: block;
  margin-bottom: 20px;
}

.inputFile__container {
  position: relative;
  border-bottom: 1px solid var(--c-primary-neutral-1);

  &.error {
    border-bottom: 1px solid var(--c-secondary-color-1);
  }
}

.inputFile__input {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;

  & + label {
    display: flex;
    visibility: visible !important;
    width: 100%;
    height: 24px;
  }

  &:focus + label,
  & + label:hover {
    cursor: pointer;
    color: var(--c-primary-color-3);

    .inputFile__reset,
    .inputFile__icon {
      color: var(--c-primary-color-3);
    }
  }
}

.inputFile__reset,
.inputFile__icon {
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 1px;
  width: 20px;
  height: 20px;

  &:hover {
    cursor: pointer;
  }
}

.inputFile__reset {
  font-size: 20px;
}
</style>
